import React from 'react';
import { EMPTY_COUNT, MESSAGE_DATETIME_FORMAT, NO_RECORDS_FOUND } from '../../../utils/constants';
import moment from 'moment';

const ContactTable = (props) => {

    const smallHeaderStyle = "custom-table-header custom-row-small";
    const fullHeaderStyle = "custom-table-header full-width";
    const numberHeaderStyle = "custom-table-header custom-row-number";
    const numberRowStyle = "custom-table-row custom-row-number";
    const smallRowStyle = "custom-table-row custom-row-small";
    const fullRowStyle = "custom-table-row full-width";
    const fullTitleStyle = "custom-table-row full-width truncate";
    const fullFlex ="flex full-width";
    const dateHeaderStyle = "custom-table-header custom-row-date";
    const dateRowStyle = "custom-table-row custom-row-date";
    

    const TableList = (
        EMPTY_COUNT === props.list.length ? (
            <div className={[fullRowStyle, " text-center"]}>{NO_RECORDS_FOUND}</div>
         ) : (
            props.list.map((row, index) => {
                return (
                    <div key={index} className={row.open ? "contact-selection" : "contact-selection text-bold"} onClick={props.viewContact.bind(this, row)}>
                        <div className={fullFlex}>
                            <div className={smallRowStyle}>
                                {row.open ? "既読" : "未読"}
                            </div>
                            <div className={numberRowStyle}>{row.contactNumber}</div>
                            <div className={dateRowStyle}>{moment(row.sendDateTime).format(MESSAGE_DATETIME_FORMAT)}</div>
                            <div className={fullTitleStyle}>{row.title}</div>
                        </div>
                    </div>
                )
            })
        )
    )

    return (
        <div className="custom-contact-table">
            <div className={fullFlex}>
                <div className={smallHeaderStyle}>既/未</div>
                <div className={numberHeaderStyle}>No.</div>
                <div className={dateHeaderStyle}>受信日時</div>
                <div className={fullHeaderStyle}>タイトル</div>
            </div>

            {props.list && TableList}
        </div>
    )
}

export default ContactTable;